<div class="jobs-list-container">
    <app-jobs-tab [jobs]="jobs$" [hideAddButton]="hideAddButton" [showSelectedColumn]="showSelectedColumn"
        [state]="state" (searchParams)="searchParamsChanged($event, getArchived)">
    </app-jobs-tab>
</div>
<mat-paginator [length]="totalJobsCount" [pageSize]="DEFAULT_PAGE_SIZE" [pageSizeOptions]="DEFAULT_PAGE_SIZE_OPTIONS"
    (page)="pageChanged($event, getArchived)" aria-label="Select page" [showFirstLastButtons]="true">
</mat-paginator>